import decodeJwt from 'jwt-decode';

export function storeTokens(accessToken: string, refreshToken: string) {
    const user: { role: string } = decodeJwt(accessToken)

    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('role', user.role)
}
